<app-breadcrumbs title="Ecommerce" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<div class="d-flex flex-lg-row flex-column mb-4">
    <div class="">
        <h4 class="fs-16 mb-1">Welcome, {{userContext!.firstName || userContext!.userName || "User" }}</h4>
        <p class="text-muted mb-0">Here's what's happening with your invoices.  Showing invoice data for the {{splineAreaChart.currentSortBy}}.</p>
    </div>
</div>

<div class="row justify-content-center d-flex">
    <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
        <div class="card card-animate card-animateBlue justify-content-center text-center">

            <div class="card-body">
                <h5 class="mb-1" style="color: #6691e7;">Total Invoiced</h5>
            </div>
            <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;">
                    <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span
                            class="counter-value">{{splineAreaChart.totalInvoiced}}</span></h4>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
        <div class="card card-animate  card-animateGreen justify-content-center text-center">

            <div class="card-body">
                <h5 class="mb-1" style="color: #13c56b;">Total Payments</h5>
            </div>
            <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;">
                    <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span
                            class="counter-value">{{splineAreaChart.totalPayments}}</span></h4>
                </div>

            </div>
        </div>
    </div>
    <div class="flex-grow-1" style="max-width: 20%; min-width: 200px; ">
        <div class="card card-animate card-animateRed justify-content-center text-center">

            <div class="card-body">
                <h5 class="mb-1" style="color: #ed5e5e;">Total Refunded</h5>
            </div>
            <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;">
                    <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span
                            class="counter-value">{{splineAreaChart.totalRefunded}}</span></h4>
                </div>

            </div>
        </div>
    </div>

    <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
        <div class="card card-animate card-animateRed justify-content-center text-center">

            <div class="card-body">
                <h5 class="mb-1" style="color: #ed5e5e;">Total Unpaid</h5>
            </div>
            <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;">
                    <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span
                            class="counter-value">{{splineAreaChart.totalUnpaid}}</span></h4>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="canViewAllInvoicesButton" class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
        <div class="card card-animate card-animatePurple justify-content-center text-center" style="cursor: pointer;"
            [routerLink]="'/invoice/list'">

            <div class="card-body">
                <h5 class="mb-1" style="color: #865ce2;">View All Invoices</h5>
            </div>
            <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;">
                    <span class="rounded fs-3">
                        <i class="bx bx-link-external" style=" color: #865ce2; font-size: 44px;"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="col-xxl-12">
    <div class="card card-height-100">
        <div class="card-header align-items-center d-flex">
            <div class="flex-grow-1">
                <div class="">
                    <h4 class="fs-16 mb-1">Invoice Balance Summary</h4>
                </div>
            </div>
            <div class="flex-shrink-0">
                <div class="dropdown card-header-dropdown" ngbDropdown>
                    <a class="text-reset dropdown-btn arrow-none" href="javascript:void(0);" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        <span class="fw-semibold text-uppercase fs-12">Sort by: </span><span
                            class="text-muted">{{splineAreaChart.currentSortBy}}<i
                                class="mdi mdi-chevron-down ms-1"></i></span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                        <a class="dropdown-item" href="javascript:void(0);"
                            (click)="getInvoiceBalanceSummary('current_year')">{{splineAreaChart.sortOptions[0]}}</a>
                        <a class="dropdown-item" href="javascript:void(0);"
                            (click)="getInvoiceBalanceSummary('last_year')">{{splineAreaChart.sortOptions[1]}}</a>
                        <a class="dropdown-item" href="javascript:void(0);"
                            (click)="getInvoiceBalanceSummary('all')">{{splineAreaChart.sortOptions[2]}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body px-0">
            <div class="mb-n3">
                <apx-chart [series]="splineAreaChart.series" [chart]="splineAreaChart.chart"
                    [dataLabels]="splineAreaChart.dataLabels" [stroke]="splineAreaChart.stroke"
                    [xaxis]="splineAreaChart.xaxis" [yaxis]="splineAreaChart.yaxis" [colors]="splineAreaChart.colors"
                    [fill]="splineAreaChart.fill" dir="ltr"></apx-chart>
            </div>
        </div>
    </div>
</div>
<div class="row justify-content-center d-flex">
    <div class="col-12">
        <div class="card">
            <div class="card-header border-0 align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1"> Requisition Status </h4>
            </div>

            <div class="card-header p-0 border-0 bg-soft-light">
                <div class="row g-0 text-center">
                    <div class="col-6 col-md" style="background-color: rgba(127, 17, 224, .03);">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalDraft}}</span></h5>
                            <p class="text-muted mb-0">Draft</p>
                        </div>
                    </div>

                    <div class="col-6 col-md" style="background-color: rgba(102, 145, 231, .03);">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalSubmitted }}</span>
                            </h5>
                            <p class="text-muted mb-0">Submitted</p>
                        </div>
                    </div>

                    <div class="col-4 col-md" style="background-color: rgba(241, 150, 59, .03);">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalProcessing}}</span>
                            </h5>
                            <p class="text-muted mb-0">Processing</p>
                        </div>
                    </div>

                    <div class="col-4 col-md" style="background-color: rgba(19, 197, 107, .03);">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalCompleted}}</span>
                            </h5>
                            <p class="text-muted mb-0">Completed</p>
                        </div>
                    </div>
                    <div class="col-4 col-md" style="background-color: rgba(237, 94, 94, .03);">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalIncompleted }}</span>
                            </h5>
                            <p class="text-muted mb-0">Incompleted</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body p-0 pb-2">
                <div class="w-100">
                    <apx-chart class="apex-charts" [series]="witnessChart.series" [chart]="witnessChart.chart"
                        [colors]="witnessChart.colors" [dataLabels]="witnessChart.dataLabels"
                        [stroke]="witnessChart.stroke" [series]="witnessChart.series" [title]="witnessChart.title"
                        [markers]="witnessChart.markers" [xaxis]="witnessChart.xaxis" [tooltip]="witnessChart.tooltip"
                        [grid]="witnessChart.grid" dir="ltr"></apx-chart>
                </div>
            </div>
        </div>
    </div>
</div>